import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { FC, ReactElement } from 'react';

import { UsersPlaceholder } from '@gem/components';
import { useTranslation } from '@gem/modules/i18n';
import { ICommonPopupsProps, Popup, useClosePopupOnNavigation } from '@gem/popups';
import { customScrollStyles, InfoBlock, InfoBlockTypes } from '@gem/ui-kit';
import { getMascotImageSrc } from '@gem/utils';

import { List } from 'APP/components/List/List';
import { User } from 'STORE/Users/User/User';

import { ISpaceBlackListPopupParams, useSpaceBlackListPresenter } from './SpaceBlackList.presenter';
import styles from './SpaceBlackList.styles.m.css';
import { SpaceBlackListItem } from './SpaceBlackListItem/SpaceBlackListItem';

export const SpaceBlackList: FC<ICommonPopupsProps<ISpaceBlackListPopupParams>> = observer(
  (props) => {
    const { t } = useTranslation();
    const presenter = useSpaceBlackListPresenter(props);
    useClosePopupOnNavigation(props.popupInstance);

    return (
      <Popup
        isOpened
        title={t('balck_list_title')}
        handlePrevStep={presenter.hasBackButton ? presenter.onBack : null}
        onClose={presenter.onClose}
      >
        <div className={classNames(styles.container, customScrollStyles.container)}>
          <List
            isLoading={presenter.isLoading}
            hasMore={presenter.hasMore}
            data={presenter.users}
            onEndReached={presenter.loadMore}
            keyExtractor={(user: User): string => user.id}
            renderItem={(user: User): ReactElement => (
              <SpaceBlackListItem
                space={presenter.space}
                user={user}
                onUnbanUser={presenter.onUnbanUser}
                onClosePopup={presenter.onClose}
              />
            )}
            ListEmptyComponent={
              <InfoBlock
                className={styles.infoBlock}
                descriptions={[t('ban_empty_ban_list')]}
                type={InfoBlockTypes.Modal}
                image={getMascotImageSrc(PROJECT_CONFIG.imageAssets.block)}
              />
            }
            SpinnerComponent={
              <UsersPlaceholder
                className={styles.placeholders}
                count={presenter.users.length > 0 ? 2 : 10}
              />
            }
          />
        </div>
      </Popup>
    );
  }
);
